<template>
  <div>
    <div class="wrapper">
      <input type="radio" name="comportamiento" id="comportamiento-1" @click="selComportamiento('ppto_inicial,ppto_final,diferencia')" />
      <input type="radio" name="comportamiento" id="comportamiento-2" @click="selComportamiento('ppto_inicial')"/>
      <input type="radio" name="comportamiento" id="comportamiento-3" @click="selComportamiento('ppto_final')"/>
      <input type="radio" name="comportamiento" id="comportamiento-4" disabled/>
      <input type="radio" name="comportamiento" id="comportamiento-5" @click="selComportamiento('diferencia')"/>

        <label for="comportamiento-1" class="comportamiento comportamiento-1">
          <div class="dot"></div>
          <span>Todos</span>
        </label>
      <label for="comportamiento-2" class="comportamiento comportamiento-2">
        <div class="dot"></div>
        <span>Presupuesto Inicial</span>
      </label>
      <label for="comportamiento-3" class="comportamiento comportamiento-3">
        <div class="dot"></div>
        <span>Presupuesto Final</span>
      </label>
      <label for="comportamiento-4" class="comportamiento comportamiento-4">
        <div class="dot"></div>
        <span>Ingresos, gastos devengados</span>
      </label>
      <label for="comportamiento-5" class="comportamiento comportamiento-5">
        <div class="dot"></div>
        <span>Diferencia</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    selComportamiento: function(option) {
      this.$store.commit("setComportamiento", option);
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Fira Sans", sans-serif;
}
html,
body {
  display: grid;
  place-items: center;
  background: #0069d9;
  font-family: "Fira Sans", sans-serif;
}
.wrapper {
  background: #fff;
  height: 80px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
}
.wrapper .comportamiento {
  background: #e0e0e0;
  height: 50px;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  margin-right: 15px;
}

.wrapper .comportamiento .dot::before {
  position: absolute;
  content: "";
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(1.5);
  transition: all 0.3s ease;
}
input[type="radio"] {
  display: none;
}
#comportamiento-1:checked:checked ~ .comportamiento-1,
#comportamiento-2:checked:checked ~ .comportamiento-2,
#comportamiento-3:checked:checked ~ .comportamiento-3,
#comportamiento-4:checked:checked ~ .comportamiento-4,
#comportamiento-5:checked:checked ~ .comportamiento-5,
#comportamiento-6:checked:checked ~ .comportamiento-6 {
  border-color: #24c6ab;
  background: #24c6ab;
}
#comportamiento-1:checked:checked ~ .comportamiento-1 .dot,
#comportamiento-2:checked:checked ~ .comportamiento-2 .dot,
#comportamiento-3:checked:checked ~ .comportamiento-3 .dot,
#comportamiento-4:checked:checked ~ .comportamiento-4 .dot,
#comportamiento-5:checked:checked ~ .comportamiento-5 .dot,
#comportamiento-6:checked:checked ~ .comportamiento-6 .dot {
  background: #fff;
}
#comportamiento-1:checked:checked ~ .comportamiento-1 .dot::before,
#comportamiento-2:checked:checked ~ .comportamiento-2 .dot::before,
#comportamiento-3:checked:checked ~ .comportamiento-3 .dot::before,
#comportamiento-4:checked:checked ~ .comportamiento-4 .dot::before,
#comportamiento-5:checked:checked ~ .comportamiento-5 .dot::before,
#comportamiento-6:checked:checked ~ .comportamiento-6 .dot::before {
  opacity: 1;
  transform: scale(1);
}

#comportamiento-1:checked:checked ~ .comportamiento-1 span,
#comportamiento-2:checked:checked ~ .comportamiento-2 span,
#comportamiento-3:checked:checked ~ .comportamiento-3 span,
#comportamiento-4:checked:checked ~ .comportamiento-4 span,
#comportamiento-5:checked:checked ~ .comportamiento-5 span,
#comportamiento-6:checked:checked ~ .comportamiento-6 span {
  color: #fff;
}

@media screen and (max-width: 1520px) {
  .wrapper .comportamiento {
    height: 40px;
    width: 140px;
    font-size: 11px;
    text-align: center;
  }
}

@media screen and (max-width: 1000px) {
    .wrapper .comportamiento {
    height: 30px;
    width: 90px;
    font-size: 8px;
  }
}

@media screen and (max-width: 770px) {
  .wrapper .comportamiento {
    height: 30px;
    width: 80px;
    font-size: 9px;
    margin-right: 7px;
  }
}
</style>
